import React from "react";
import "./FeatureCard.css";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


// Main components ---------------------------
const FeatureCard = ({ title, description, icon }) => {
const navigate = useNavigate();
  return (
    <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 feactureCard">
      <div className="flex items-center justify-center text-5xl text-teal-400 mb-4">
        <span className="SpanIcon">
          <img src={icon} alt={title} className="feacturedIcon" />
        </span>
      </div>
      <h3 className="text-2xl font-semibold text-yellow-400 feacturedTitle">
        {title}
      </h3>
      <p className="text-gray-300 mt-2 feacturedDescription">{description}</p>
      <div className="mt-4 text-center cardFooterDetails">
        {/* <span><SubdirectoryArrowRightIcon/></span> */}

 <Link to="/ourservices">
        <div className="button">
         
            <button
            // onClick={() => navigate("/ourservices")}
              className="bg-teal-500 text-white px-6 py-2 rounded-full hover:bg-teal-600 bookCallbutton"
            >
             Check Our Services
            </button>
          
        </div>
        </Link>
      </div>
    </div>
  );
};

export default FeatureCard;
